import { __extends } from "tslib";
import * as React from 'react';
// tslint:disable-next-line: max-line-length
import { deprecatedTypographyTypes, defaultDeprecatedTypographyType } from '.';
import { namespacedClassnames } from '../common/namespace-classes';
var configToClassName = function (c) {
    return "color-" + c.color;
};
/** @deprecated please use \<Text/> */
var DeprecatedText = /** @class */ (function (_super) {
    __extends(DeprecatedText, _super);
    function DeprecatedText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeprecatedText.prototype.render = function () {
        var props = this.props;
        var type = props.type || defaultDeprecatedTypographyType;
        var config = deprecatedTypographyTypes[type];
        var ellipsis = props.ellipsis;
        var ellipsisClass = ellipsis ? "ellipsis-" + (ellipsis === true ? 1 : props) : '';
        var cn = namespacedClassnames('deprecated-text', type, props.className, configToClassName(config), ellipsisClass);
        var style = {
            fontSize: config.size,
            fontWeight: config.weight,
            fontStyle: (config.style || 'normal')
        };
        return React.createElement("div", { className: cn, ref: props.ref, onClick: props.onClick, style: style }, props.children);
    };
    return DeprecatedText;
}(React.PureComponent));
export { DeprecatedText };
//# sourceMappingURL=text.js.map